import DateFnsUtils from '@date-io/date-fns';
import {
    KeyboardDatePicker,
    KeyboardDatePickerProps,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';

export default function DatePickerInput({
    id,
    variant,
    label,
    value = '',
    ...rest
}: KeyboardDatePickerProps) {
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                allowKeyboardControl={false}
                variant={'dialog'}
                disableFuture={true}
                format={'dd/MM/yyyy'}
                placeholder={'dd/mm/yyyy'}
                id={id}
                label={label}
                value={value}
                InputLabelProps={{ shrink: true }}
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
                InputProps={{
                    readOnly: true,
                }}
                inputVariant={'outlined'}
                {...rest}
            />
        </MuiPickersUtilsProvider>
    );
}
